<template>
  <div class="documents col-md-12" v-if="vesselDocuments.length > 0">
    <div>
      <slot name="documents-help">
      <div class="form-fieldhelp" style="right: 15px">
        <label>?</label>
        <div class="form-fieldhelp-text">
          <div>
            Прикрепите сканы документов в соответствующие для них разделы.
            <br/>Максимально допустимый размер файла - 2 МБ.
            <br/>Допустимые расширения файлов: jpg, jpeg, png, pdf, bmp, webp.
            <br/>Заявки для иностранных граждан без прикрепленных обязательных документов не принимаются.
          </div>
        </div>
      </div>
      </slot>
      <h4>Документы</h4>
    </div>
    <div class="panel-group">
      <template v-for="(documentObj, documentKey) in vesselDocuments">
        <div :id="`document-block-${documentObj.type.short_name}`" :key="documentKey">
          <uppy-uploader
            v-model="vessel.documents[documentObj.type.short_name]"
            :dashboard-show-condition="isNew || isDuplicate || isDraft"
            :document-comment="documentObj.comment"
            :document-key="`vessel-documents-${documentKey}`"
            :document-name="documentObj.type.name"
            :documents-show-condition="isCheck || isView"
            :files-request="requestVesselFiles"
            :get-uuid="(file) => file.uuid"
            :has-errors="blockHasErrors(documentObj.type.short_name)"
            :key="`${vessel.uuid}-${documentObj.type.short_name}`"
            @file-removed="onFileRemove($event, documentObj.type.short_name)"
            ref="uploader"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { ApiClient } from '@/helpers/api-client/ApiClient'
import UppyUploader from '@/common/components/inputs/UppyUploader'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'
import applicationInputMixin from '@/common/mixins/applicationInputMixin'
import applicationFormContextMixin from '@/common/mixins/applicationFormContextMixin'

export default {
  name: 'VesselDocumentsFormBlock',

  components: {
    UppyUploader
  },

  mixins: [
    applicationFormMixin,
    applicationInputMixin,
    applicationFormContextMixin
  ],

  model: {
    prop: 'vessel'
  },

  props: {
    vessel: {
    },
    vesselDocuments: {
      type: [Object, Array],
      default: () => []
    }
  },

  data: () => ({
    baseUrl: process.env.VUE_APP_API_BASE_URL
  }),

  methods: {
    blockHasErrors (field) {
      console.log(Boolean(this.hasError(this.errors?.vessels, field)))
      return Boolean(this.hasError(this.errors?.vessels, field))
    },

    async fileRemoved (uuid, ext) {
      await ApiClient.removeUploadedDocument({ uuid, ext })
    },

    getUUID (file) {
      return file.uuid
    },

    onFileRemove (file, docName) {
      const ext = file.name.split('.').pop().toLowerCase()

      this.fileRemoved(file.meta.uuid, ext)
      this.removeVesselFile(docName, file.meta.uuid + '.' + ext)
    },

    removeVesselFile (doc, uuid) {
      if (doc && this.vessel.files[doc]) {
        const fileInd = this.vessel.files[doc].findIndex(
          (item) => item.uuid === uuid
        )
        if (Number(fileInd) > -1) {
          this.vessel.files[doc].splice(fileInd, 1)
        }
      }
    },

    async requestVesselFiles () {
      const vue = this;

      await ApiClient.getUploadDocuments({
        personal_ids: JSON.stringify([this.visitor.personal.id]),
        doc_types: JSON.stringify(this.nationalityDocuments.map((natDoc) => natDoc.document.short_name))
      }).then(function (response) {
        const responseData = response.data.data
        vue.visitor.files = responseData[vue.visitor.personal.id]
      })
    }
  }
};
</script>
